module.exports = __webpack_public_path__ + "img/infinity_blue.d737ab7f.svg";